import { useEffect, useState } from "react";

export const Delayed = ({ waitBeforeShow = 1000, children }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setVisible(true);
    }, waitBeforeShow);

    return () => clearTimeout(timeoutId);
  }, [waitBeforeShow]);

  return visible ? children : null;
};
